import { html } from 'lit';
import { App } from '@common/types/model.d.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';

//
// renders a single app consent block
//
// {app name}
// {app consent status}
//
export const singleAppConsentEdit = function render(this: TefComs4p, app: App) {
  return html`
    <one-checkbox ?checked="${app.granted}" @change=${(e : PointerEvent) => { this.toggleAppConsent(e, app); }}>
      <one-text size="lg">
          ${app.name}
      </one-text>
    </one-checkbox>
  `;
};
